module.exports = __webpack_public_path__ + "img/13-onebg.b75b9b71.jpg";